import { useMutation } from '@tanstack/react-query';
import { api } from 'lib/httpClient';
import { ApiResponse } from 'further-types/api';
import { Api } from 'further-types/investor';
import { useNotification } from 'hooks/ui/useNotification';
import trpcApi from 'lib/trpcClient';
import { AxiosError } from 'axios';

interface BankDetailsRequest extends Api.UpdateBankDetailsRequest {
  investorId: string;
}

export default function useSetBankDetails() {
  const utils = trpcApi.useUtils();
  const notification = useNotification();

  return useMutation({
    mutationFn: async (bankDetails: BankDetailsRequest) => {
      const { data: result } = await api.put<ApiResponse<unknown>>(
        `investor/add-bank-detail/${bankDetails?.investorId}`,
        bankDetails,
      );
      return result;
    },
    throwOnError: false,
    onSuccess: async (_: unknown, bankDetails) => {
      await utils.investor.getInvestor.invalidate({
        investorId: bankDetails.investorId,
      });
    },
    onError: (error: AxiosError<{ responseMsg: string }>) => {
      notification.error(
        error.response?.data.responseMsg ||
          'Something went wrong when trying to set bank details.',
      );
    },
  });
}
